// extracted by mini-css-extract-plugin
module.exports = {"view-submission-data":"view-submission-data__view-submission-data___2PSuT"};